import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';
import {UseGeolocationState} from 'presentation/hooks/useGeolocation/types';

enum SortOrderType {
	NONE = 'NONE',
	ASC = 'ASC',
	DESC = 'DESC',
}

enum ppoNetworkTypeEnum {
	ALL = 'TODOS',
	SELF_NETWORK = 'REDE_PROPRIA',
	ACCREDITED_NETWORK = 'REDE_CREDENCIADA',
}

type GuideStore = {
	searchByProviderName: Record<PlanTypeEnum, string>;
	selectedDistrict: string;
	coordinates: UseGeolocationState['coords'];
	activeStep: Record<PlanTypeEnum, number>;

	setSearchByProviderName: (type: PlanTypeEnum, value: string) => void;
	setSelectedDistrict: (value: string) => void;

	resetHealthStates: () => void;
	resetOdontoStates: () => void;
	setCoordinates: (value: UseGeolocationState['coords']) => void;
};

type PpoNetworkStore = {
	ppoNetworkType: ppoNetworkTypeEnum;
	setPpoNetworkType: (value: ppoNetworkTypeEnum) => void;
	resetPpoNetworkType: () => void;
};

export {SortOrderType, ppoNetworkTypeEnum};
export type {GuideStore, PpoNetworkStore};
